import { render } from "./SuspenseWithError.vue?vue&type=template&id=8e07c7ac&ts=true"
import script from "./SuspenseWithError.vue?vue&type=script&lang=ts"
export * from "./SuspenseWithError.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.17_vue@3.2.37_webpack@5.69.0_@swc+core@1.12.11_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__